

import {
  FETCH_BLOCKBUSTER_REQUEST,
  FETCH_BLOCKBUSTER_SUCCESS,
  FETCH_BLOCKBUSTER_FAILURE,
} from "../actions/blockbusterActions";

const initialState = {
  loading: false,
  deals: [],
  error: null,
};

export default function blockbusterReducer(state = initialState, action) {
  switch (action.type) {
    case FETCH_BLOCKBUSTER_REQUEST:
      return { ...state, loading: true, error: null };
    case FETCH_BLOCKBUSTER_SUCCESS:
      return { loading: false, deals: action.payload, error: null };
    case FETCH_BLOCKBUSTER_FAILURE:
      return { loading: false, deals: [], error: action.payload };
    default:
      return state;
  }
}
